import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import Layout from "../../../../vendor_core/core/src/utils/Layout";
import SceneView from "../../../../vendor_core/core/src/views/SceneView";
import SpineAnimation from "../../../../vendor_core/core/src/views/SpineAnimation";

class LogoHelper {
    public init() {
        let isChinese: boolean = (GameModel.lang == "zh-cn" || GameModel.lang == "zh-tw");

        let menuLogoScene: SceneView = ViewManager?.getLayer("MenuLogo")?.getCurrentScene();
        let bannerScene: SceneView = ViewManager?.getLayer(DefaultLayers.Banners)?.getCurrentScene();
        const logoAnim: SpineAnimation = menuLogoScene?.spineAnimations?.get("logo");
        const logoAnimBanner: SpineAnimation = bannerScene?.spineAnimations?.get("logo");
        logoAnim?.skeleton?.setSkinByName(isChinese ? "chinese" : "english");
        logoAnimBanner?.skeleton?.setSkinByName(isChinese ? "chinese" : "english");

        const scaleNum: number = 0.5 * Layout.globalScale;
        logoAnim?.scale.set(scaleNum, scaleNum);
        logoAnimBanner?.scale.set(scaleNum, scaleNum);
        bannerScene.orientationChangeCallback = () => {
            if (!Layout.isLandscape()) {
                logoAnimBanner?.scale.set(scaleNum, scaleNum);
                logoAnimBanner?.play("logo");
            }
            logoAnim?.scale.set(scaleNum, scaleNum);
            logoAnim?.play("logo");
        }

        logoAnim?.play("logo");
        logoAnimBanner?.play("logo");
    }
}

export default new LogoHelper()